import { Component } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';

import { DataService } from '../../services/data';
import { LocalStorageService } from '../../services/local-storage';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
    selector: 'page-changepassword',
    templateUrl: 'change-password.html'
})
export class ChangePasswordPage {
    token: any;

    currentPassword: string = "";
    newPassword: string = "";
    newPasswordAgain: string = "";
    errorMessage: string = "";

	newPasswordChangeObservable;
    newPasswordSubHandler: any;
    
	newPasswordAgainChangeObservable;
    newPasswordAgainSubHandler: any;

    constructor(public nav: NavController, public data: DataService, 
            public localStorage: LocalStorageService, public toast: ToastController) {
        this.localStorage.getEntity("authtokens")
        .then(token => this.token = token );
    }

    canSubmit() {
        return (this.currentPassword.trim()) && (this.currentPassword.trim() != null) 
                && (this.newPassword.trim()) && (this.newPassword.trim() != null) 
                && (this.newPassword == this.newPasswordAgain);
    }

    changePassword() {
        this.data.updateUserPassword(this.token.id, this.newPassword)
        .then(tokens => {
            let toast = this.toast.create({
                message: 'Successfully updated password.',
                duration: 2000,
            });
            toast.present();
		});
    }

    onNewPasswordChange() {	
        if (!this.newPasswordChangeObservable) {
            Observable.create(observer => {
                this.newPasswordChangeObservable = observer;
            }).debounceTime(400)
              .subscribe((searchValue) => { this.checkIfPasswordMatch() });
        }

		this.newPasswordChangeObservable.next();
    }
    
    onNewPasswordAgainChange() {	
        if (!this.newPasswordAgainChangeObservable) {
            Observable.create(observer => {
                this.newPasswordAgainChangeObservable = observer;
            }).debounceTime(400)
              .subscribe((searchValue) => { this.checkIfPasswordMatch() });
        }

		this.newPasswordAgainChangeObservable.next();
    }
    
    checkIfPasswordMatch() {
        if (this.newPassword != this.newPasswordAgain) {
            this.errorMessage = "New passwords don't match.";
        } else {
            this.errorMessage = "";
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/profile/change-password.ts